module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Confirming email..."
    }
  }, [_c('div', {
    staticClass: "fs-2r text-muted text-center mt-2"
  }, [_vm._v("\n    Confirming Email Address...\n  ")]), _vm._v(" "), _c('Loader', {
    staticClass: "mt-4"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-6d203dfe"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmEmail.vue
// module id = 1060
// module chunks = 0